import { render, staticRenderFns } from "./V2AddressForm.vue?vue&type=template&id=24ad4ab9&scoped=true&"
import script from "./V2AddressForm.vue?vue&type=script&lang=js&"
export * from "./V2AddressForm.vue?vue&type=script&lang=js&"
import style0 from "./V2AddressForm.vue?vue&type=style&index=0&id=24ad4ab9&lang=scss&scoped=true&"
import style1 from "./V2AddressForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad4ab9",
  null
  
)

export default component.exports